import styled, { useTheme } from 'styled-components'

import { NETWORK_COLOR_MAP } from '@root/entities/network/ui/constants'
import { NetworkIcon } from '@root/entities/network/ui/network-icon/network-icon'

import type { Network } from '@root/entities/network'
import type { ClassNameProps } from '@root/shared/react'
import type { Theme } from '@root/shared/ui-kit'

type Props = {
  network: Network.Network
  size: number
  dark?: boolean
  disabled?: boolean
  iconRatio?: number
} & ClassNameProps

const ICON_RATION = 0.6

export const CurrencyNetworkIcon = ({
  network,
  size,
  className,
  dark = false,
  disabled = false,
  iconRatio = ICON_RATION,
}: Props) => {
  const theme = useTheme()
  const [iconColor, bgColor] = resolveNetworkColors(network, dark, theme)

  return (
    <Root
      $size={size}
      $color={disabled ? 'var(--background-4)' : bgColor}
      className={className}
    >
      <NetworkIcon
        network={network}
        size={Math.round(size * iconRatio)}
        color={disabled ? 'var(--background-9)' : iconColor}
      />
    </Root>
  )
}

const resolveNetworkColors = (
  network: Network.Network,
  dark: boolean,
  theme: Theme,
): [string, string] => {
  if (network === 'ethereum') {
    return dark ? ['#fff', '#111'] : ['#fff', theme.palette['ethereum'][9]]
  }

  return dark
    ? [theme.palette[NETWORK_COLOR_MAP[network]][9], '#111']
    : ['#fff', theme.palette[NETWORK_COLOR_MAP[network]][9]]
}

const Root = styled.span<{
  $size: number
  $color: string
}>`
  background-color: ${({ $color }) => $color};
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;

  border-radius: 50%;
  display: grid;
  place-items: center;
`
